import ILDefaultAva from 'assets/icons/default-ava-profile-user.svg'
import Flatpickr from 'react-flatpickr'
import { useDispatch, useSelector } from 'react-redux'
import {
  Badge,
  Card,
  CardBody,
  CardText,
  Col,
  FormGroup,
  Label,
  Row,
} from 'reactstrap'
import { purchaseCommodityCheckUser } from '../purchaseCommodityAction'

import {
  setIsModalOpenAddAddressBook,
  setSearchAddressBook,
} from 'features/private-views/address-book/addressBookSlice'
import InputAddressBook from 'features/private-views/address-book/InputAddressBook'
import ModalAddContact from 'features/private-views/address-book/ModalAddContact'
import { Indonesian } from 'flatpickr/dist/l10n/id'
import ModalUnverifSeller from 'private-views/transactions/ModalUnverifSeller'
import { useEffect, useRef, useState } from 'react'
import { AlertCircle, Calendar } from 'react-feather'
import {
  resetErrorMsg,
  setInitialSeller,
  setNewSeller,
  setProject,
  setTrxDate,
} from '../purchaseCommoditySlice'
import {
  setIsModalOpenAddProject,
  setSearchProject,
} from 'features/private-views/project/projectSlice'
import ModalAddProject from 'features/private-views/project/ModalAddProject'
import InputProject from 'features/private-views/project/InputProject'

const UserInfo = () => {
  const dispatch = useDispatch()

  const { isModalOpenAddAddressBook } = useSelector((e) => e.addressBook)
  const { profile } = useSelector((e) => e.dashboard)
  const { orders, errorMessage } = useSelector(
    (state) => state.purchaseCommmodity,
  )
  const { seller } = orders

  const [savedContacts, setSavedContacts] = useState([])
  const [phoneNum, setPhoneNumber] = useState('')
  const [isOpenModal, setIsOpenModal] = useState(false)

  const toggleOpenCloseAddContact = () => {
    dispatch(setIsModalOpenAddAddressBook(!isModalOpenAddAddressBook))
  }

  const handleSubmit = (phoneOrEmail) => {
    if (phoneOrEmail) {
      dispatch(resetErrorMsg(''))
      dispatch(
        purchaseCommodityCheckUser({
          search: encodeURIComponent(phoneOrEmail),
          type: 'BUY',
        }),
      )
    }
  }

  const handleFinishedCheckNumber = (payload) => {
    setIsOpenModal(false)
    dispatch(setNewSeller({ ...payload, phoneNumber: phoneNum }))
  }

  useEffect(() => {
    if (seller && seller?.profileStatus === 'UNREGISTERED') {
      setIsOpenModal(true)
    }
  }, [seller])

  useEffect(() => {
    if (profile?.userId) {
      const saved = JSON.parse(
        localStorage.getItem(`savedContacts-${profile?.userId}`),
      )
      setSavedContacts(saved ?? [])
    }
  }, [profile])

  // ADDRESS BOOK
  const addressBookRef = useRef(null)

  // const [dataSeller, setDataSeller] = useState('')
  const [selectedContact, setSelectedContact] = useState(null)
  const [isFetchingAddressBook, setIsFetchingAddressBook] = useState(false)

  const handleSelectedContact = (contact) => {
    // setDataSeller(contact)
    setSelectedContact(contact)
  }

  useEffect(() => {
    const relationPhoneOrEmail =
      selectedContact?.relationPhoneNumber ?? selectedContact?.relationEmail
    if (relationPhoneOrEmail) {
      handleSubmit(relationPhoneOrEmail)
      setPhoneNumber(relationPhoneOrEmail)
      dispatch(setInitialSeller(null))
      dispatch(resetErrorMsg(''))
    } else {
      setPhoneNumber('')
      setSelectedContact(null)
      dispatch(setInitialSeller(null))
      dispatch(resetErrorMsg(''))
    }
  }, [selectedContact])

  // HANDLE AUTO FOCUS
  useEffect(() => {
    setTimeout(() => {
      addressBookRef.current?.focus()
    }, 0)
  }, [])

  return (
    <>
      <ModalUnverifSeller
        toggle={() => {
          setPhoneNumber('')
          setSelectedContact(null)
          setIsOpenModal(!isOpenModal)
          dispatch(setInitialSeller(null))
          dispatch(resetErrorMsg(''))
        }}
        isOpen={isOpenModal}
        handleFinished={handleFinishedCheckNumber}
        selectedContact={selectedContact}
      />
      {/* MODAL ADD ADDRESS BOOK */}
      <ModalAddContact
        isOpen={isModalOpenAddAddressBook}
        toggle={toggleOpenCloseAddContact}
        // isOutsideAddressBook
        // isPhoneUnRegistered
        // isPhoneRegistered
      />
      <Card body className="custom-container m-0 m-auto border-0 shadow-sm">
        <Row>
          <Col>
            <Card className="border-0">
              <CardBody>
                <CardText tag="h5" className="text-md">
                  Pembelian
                </CardText>
                <FormGroup className="mt-4">
                  <Label>Tanggal Transaksi</Label>
                  <div className="d-flex align-items-center justify-content-center border rounded">
                    <Calendar size={17} className="ms-3" />
                    <Flatpickr
                      options={{
                        locale: Indonesian,
                        dateFormat: 'd-M-Y',
                        defaultDate: new Date(),
                        maxDate: new Date(),
                        onClose: (selectedDate, dateStr, instance) => {
                          dispatch(setTrxDate(selectedDate[0]))
                        },
                      }}
                      className="form-control flat-picker bg-transparent border-0 shadow-none"
                    />
                  </div>
                </FormGroup>
                <div className="mb-2" data-testid="purchase-form-seller-search">
                  <InputAddressBook
                    title="Beli dari"
                    placeholderDesc="Cari nama atau nomor handphone dari daftar kontak Anda"
                    onSelectContact={handleSelectedContact}
                    fieldName="phoneNumber"
                    editValue={
                      selectedContact?.relationPhoneNumber
                        ? `${selectedContact?.relationName} (${selectedContact?.relationPhoneNumber})`
                        : selectedContact?.relationEmail
                          ? `${selectedContact?.relationName} (${selectedContact?.relationEmail})`
                          : selectedContact?.relationName
                    }
                    onClickAdd={(localSearch) =>
                      dispatch(setSearchAddressBook(localSearch))
                    }
                    isOutsideAddressBook
                    onFetchingChange={setIsFetchingAddressBook}
                    innerRef={addressBookRef}
                    isRecentTrx
                    isCloseSelection={orders?.seller ? true : false}
                    valueName={orders?.seller ? orders?.seller?.fullName : ''}
                  />
                </div>

                {/* <Form onSubmit={(e) => handleSubmit(e, phoneNum)}>
                  <FormGroup>
                    <Label for="phone" className="text-sm">
                      Beli dari
                    </Label>
                    <InputGroup>
                      <InputPhoneNumber
                        placeholder="Masukkan nomor handphone penjual"
                        value={phoneNum}
                        setValue={(e) => {
                          setPhoneNumber(e)
                          dispatch(setInitialSeller(null))
                          dispatch(resetErrorMsg(''))
                        }}
                        name="phoneNumber"
                        id="phoneNumber"
                      />

                      <CustomButton
                        color="transparent"
                        className="border text-normal"
                        type="submit"
                      >
                        Cek
                      </CustomButton>
                    </InputGroup>
                    <span className="text-xs">
                      Contoh: 0813xxxx atau 62813xxxx
                    </span>
                  </FormGroup>
                </Form> */}
                {errorMessage && (
                  <FormGroup>
                    <small className="text-danger">
                      <AlertCircle size={15} /> {errorMessage}
                    </small>
                  </FormGroup>
                )}
              </CardBody>
            </Card>
            {seller && !isFetchingAddressBook ? (
              <CardBody className="py-0">
                <CardText tag="h6" className="text-sm fw-semibold">
                  Info penjual
                </CardText>
                <Row>
                  <Col>
                    <Card
                      className="border-0 shadow-sm"
                      style={{ minHeight: 68 }}
                    >
                      <CardBody>
                        <div className="flex-centered justify-content-between">
                          <div className="flex-centered gap-2">
                            <img
                              src={
                                seller?.partnership?.logo ??
                                seller.profileImg ??
                                ILDefaultAva
                              }
                              alt="ava"
                              width={36}
                              height={35}
                              className="rounded-circle"
                            />
                            <div className="d-flex flex-column">
                              <span className="text-sm fw-semibold">
                                {seller?.partnership?.name ?? seller?.fullName}
                              </span>
                              {seller?.otherPicUser?.fullName && (
                                <span className="text-muted" style={{ fontSize: 12 }}>
                                  PIC: {seller?.otherPicUser?.fullName}
                                </span>
                              )}
                            </div>
                          </div>
                          {seller?.profileStatus === 'REGISTERED' && (
                            <Badge size="sm" disabled className="badge-verify">
                              Terdaftar
                            </Badge>
                          )}
                          {seller?.profileStatus === 'VERIFIED' && (
                            <Badge size="sm" disabled className="badge-verify">
                              Terverifikasi
                            </Badge>
                          )}
                          {seller?.profileStatus === 'Belum Terverifikasi' && (
                            <Badge size="sm" disabled className="badge-warning">
                              {seller?.profileStatus}
                            </Badge>
                          )}
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col>
                    {seller?.bankAccountNumber && seller?.bankAccountName && (
                      <Card
                        className="border-0 shadow-sm"
                        style={{ minHeight: 68 }}
                      >
                        <CardBody>
                          <div className="d-flex justify-content-between flex-column">
                            <div className="flex-centered justify-content-start gap-1">
                              <img
                                src={seller?.bankLogo}
                                alt="ava"
                                width={18}
                                height={18}
                              />
                              <span style={{ fontSize: 14 }}>
                                {seller?.bankAccountNumber}
                              </span>
                            </div>
                            <div
                              className="fw-semibold"
                              style={{ fontSize: 14 }}
                            >
                              {seller?.bankAccountName}
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    )}
                  </Col>
                </Row>
              </CardBody>
            ) : (
              <></>
            )}
          </Col>
        </Row>
      </Card>
    </>
  )
}

export default UserInfo
